import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PriceCalc from './PriceCalc.js';
import './pricing.css';
import Button from '@material-ui/core/Button';


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonBack: {
   
    textTransform: 'none',
    fontSize: '14px',
    padding: '3px 6px',
    // marginLeft:"10px",
    color: '#203b60',
    backgroundColor: '#f2f2f2',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    
  },
  button: {
    margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    fontWeight:'600',
    padding: '3px 6px',
    border: '1px solid',
    color: 'white',
    // lineHeight: 1.5,
    // backgroundColor: 'rgb(114, 165,199)',
    backgroundColor:'rgb(37,106,167)',
    borderColor:'rgb(37,106,167)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    '&:hover': {
      backgroundColor: '#203b60',
      borderColor: '#203b60',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
    
  },
  textField: {
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
    // width: 200,
    textAlign: "center",
    color: "#203b60",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
});

class PriceGrid extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: 0,
      total_month:0,
      
    }
    this.userChange = this.userChange.bind(this);
    this.getTotalApps = this.getTotalApps.bind(this);
    this.getTotalMonth = this.getTotalMonth.bind(this);
  }

  userChange(event) {
    this.setState({
      users: event.target.value
    })
  }

  getTotalMonth() {
    var total;

    var users = (this.props.users * this.props.prices.user[this.props.period])
    var total_users = users - (users * this.props.prices.user.discount_new_user)
    
    total = this.getTotalApps() + total_users + (this.props.support[this.props.period] || 0)
    

    return total
  }

  getTotalApps(){
    var total = 0;
    this.props.apps.map(function(app){
      
      
      total += app[this.props.period]
    }.bind(this))
   
    // this.setState({
    //   total:total
    // })
    return total
  }

   round(num, decimales = 2) {
    var signo = (num >= 0 ? 1 : -1);
    num = num * signo;
    if (decimales === 0) //con 0 decimales
        return signo * Math.round(num);
    // round(x * 10 ^ decimales)
    num = num.toString().split('e');
    num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
    // x * 10 ^ (-decimales)
    num = num.toString().split('e');
    return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
}





  render() {
    const { classes } = this.props;
    return (
      <div>
        <table className='price-grid-table'>
          <tbody>
            <tr>
              <td><strong> {this.props.users}</strong> <span>Usuarios</span></td>
              <td style={{ textAlign: 'right' }}>$ {this.props.users * this.props.prices.user[this.props.period]} USD</td>

            </tr>

            <tr>
              <td><span>Descuento para Usuarios:</span></td>
              <td style={{ textAlign: 'right', color: 'red' }}>-${this.round((this.props.users * this.props.prices.user[this.props.period]) * this.props.prices.user.discount_new_user)} USD</td>

            </tr>

            <tr>
              <td><span> <strong>{this.props.apps.length || 0}</strong> Aplicaciones</span></td>
              <td style={{ textAlign: 'right' }}>${this.getTotalApps()} USD</td>

            </tr>

            <tr>
              <td><span>  Soporte {this.props.support.name}  </span></td>
              <td style={{ textAlign: 'right' }}>${this.props.support[this.props.period] || 0} USD</td>

            </tr>

            <tr >
              <td className="price-grid-total">
                <span>
                  <strong>Total Mensual</strong><sup>(1)</sup>
                </span>

              </td>
              <td style={{ textAlign: 'right' }}>${this.getTotalMonth()} USD</td>


            </tr>
          </tbody>


        </table>
        {this.props.period === 'year' &&
          <div className="small-conditions">
            <small ><sup>(1)</sup>:Facturado anualmante ${(this.getTotalMonth()) * 12} USD</small>
          </div>
        }

        <div className="buy-buttons">
          <Button variant="contained" onClick={this.props.buy} className={classes.button}>
            Compre Ahora
          </Button>
          {/* <Button variant="contained" onClick={this.props.saveSelection} className={classes.buttonBack}>
            Guardar mi selección
          </Button> */}
          <Button onClick={this.props.saveSelection} variant="contained" className={classes.buttonBack}>
                     Descargue su propuesta
              </Button>
          
        </div>
        

      </div>


    );
  }
}


PriceGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PriceGrid);
// export default AppsGrid;